export default __webpack_public_path__ + "static/media/209.4c6790e0.jpg";